/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-04-16 19:53:22
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MTabBar from '../../../../../components/MTabBar';
import { Icon } from 'antd-mobile'

import backPng from '../../../../../images/mine/back.png'
import relieblePng from '../../../../../images/mine/relieble.png'
import portraitPng from '../../../../../images/mine/portrait.png'
import kefuPng from '../../../../../images/mine/kefu.png'
import anliPng from '../../../../../images/mine/anli.png'
import baogaoPng from '../../../../../images/mine/baogao.png'
import quitPng from '../../../../../images/mine/quit.png'
import heartPng from '../../../../../images/mine/heart.png'
import heartOutLinePng from '../../../../../images/mine/heartOutLine.png'
import zixunPng from '../../../../../images/mine/zixun.png'

import MFooter from "../../../../../components/MFooter";
import MHead from "../../../../../components/MHead";
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../../../constants/Profile";
import YSFClass from '../../../../../class/YSFClass'
import { logout } from "../../../../Account/actions/UserAction";
import { Modal } from 'antd-mobile';
const alert = Modal.alert;
const Mine = ({ dispatch, router }) => {

  const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
  const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER))

  // useEffect(() => {
  //   if (!token) {
  //     window.location.href = '/login'
  //   }
  // }, [token])
  const login = () => {
    // window.location.href = '/login'
    router.navigate({
      pathname: `/login`,
      search: `?redirect=${encodeURIComponent(window.location.pathname)}`,
    })
  }

  const _logout = () => {
    alert('提示', '是否退出登录？', [
      { text: '取消', onPress: () => console.log('cancel') },
      {
        text: '确定',
        onPress: () => {
          dispatch(logout())
          setTimeout(() => {
            login()
          }, 500)
        }
      },
    ])

  }

  const goCase = () => {
    router.navigate('/case');
  }

  const goAbout = () => {
    window.location.href = 'https://activity.ixuanzhi.com/rlb/YearEndReport/about'
  }

  const goReport = () => {
    window.location.href = 'https://activity.ixuanzhi.com/rlb/YearMiddleReport2024/0'
  }

  const goKF = () => {
    YSFClass.ysf.open()
  }
  const goZX = () => {
    // YSFClass.ysf.open()
    router.navigate('/infoCenterList');
  }


  const goCollect = () => {
    if (token) {
      router.navigate('/collect');
    } else {
      login()
    }
  }

  return (
    <>
      {
        <div className="tabbarBottom mineReport">
          <MHead isBack={false} />
          <div className="mineReportList">

            <div className="mineReportListItem">
              {
                user ?
                  <>
                    <img src={user.portrait} />
                    <p>{user.fullName}</p>
                  </>
                  :
                  <>
                    <img src={portraitPng} />
                    <p className="loginBtn" onClick={login}>注册/登录</p>
                  </>
              }

            </div>

            <div className="mineReportListItem" onClick={goCollect}>
              <img src={heartPng} />
              <p>我的收藏</p>
              <Icon type={'right'} />
            </div>

            <div className="mineReportListItem" onClick={goAbout}>
              <img src={relieblePng} />
              <p>关于瑞莱博</p>
              <Icon type={'right'} />
            </div>

            <div className="mineReportListItem" onClick={goCase}>
              <img src={anliPng} />
              <p>选址典型案例</p>
              <Icon type={'right'} />
            </div>


            <div className="mineReportListItem" onClick={goReport}>
              <img src={baogaoPng} />
              <p>半年度高标仓报告</p>
              <Icon type={'right'} />
            </div>

            <div className="mineReportListItem" onClick={goKF}>
              <img src={kefuPng} />
              <p>在线客服</p>
              <Icon type={'right'} />
            </div>
            <div className="mineReportListItem" onClick={goZX}>
              <img src={zixunPng} />
              <p>资讯中心</p>
              <Icon type={'right'} />
            </div>

            {
              token && <div className="mineReportListItem" onClick={_logout}>
                <img src={quitPng} />
                <p>退出登录</p>
              </div>
            }


          </div>
          <MFooter />

        </div>
      }


      <MTabBar router={router} index={3} />
    </>

  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(Mine);
